import React, { useCallback } from 'react'
import './opportunity-detail-scroll-to-top.scss'
import { useOpportunitySectionNavigation } from './opportunity-section-navigation-context'

const OpportunityDetailScrollToTop = () => {
  const { isVisible } = useOpportunitySectionNavigation()

  const handleClick = useCallback(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }, [])

  if (!isVisible) {
    return null
  }

  return (
    <button
      type='button'
      className='opportunity-detail-scroll-to-top'
      onClick={handleClick}
      aria-label='Scroll to top'
      data-testid='opportunity-detail-scroll-to-top'
    >
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='20'
        height='20'
        viewBox='0 0 20 20'
        fill='none'
        aria-hidden='true'
      >
        <path d='M10 4L4 10H7V16H13V10H16L10 4Z' fill='currentColor' />
      </svg>
    </button>
  )
}

export { OpportunityDetailScrollToTop }
